<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li>
          </ul>
        </div>
      </div>
    </div>
    <app-maser-page-header></app-maser-page-header>
    <div *ngIf="is_route_change_available">
      <div class="row">
        <div class="col-3"></div>
        <div class="col-3"></div>
        <div class="col-3">
          <div class="form-group">
            <select class="form-control dropdown_box" #route_id matNativeControl style="margin-top: 20px;" >
              <option value="" style="font-size: 16px;">Select Route</option>
              <option *ngFor="let route of routes" [value]="route['id']" style="font-size: 16px">{{route['name']}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-1" style="margin: 23px;">
          <button mat-raised-button (click)="routeSelected(route_id.value)">Submit</button>
        </div>
      </div>
      <div *ngIf="selected_route_id != null">
        <div class="row">
          <div class="col example-container">
            <div style="background: bisque; padding: 15px;">
              <span style="font-weight: bold; font-size: 2rem;">Unattached Booths</span>
              <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="unassigned_business"
                [cdkDropListConnectedTo]="[doneList]" class="example-list"
                (cdkDropListDropped)="drop($event, 'route_to_business')">
                <div class="example-box" *ngFor="let business of unassigned_business" cdkDrag [cdkDragData]="business"
                  style="    font-size: 18px;padding: 13px;">
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  {{business['name']}}
                </div>
              </div>
            </div>
            <div style="background: gainsboro; padding: 15px;    margin-top: 17px;">
              <span style="font-weight: bold; font-size: 2rem;">All Businesses</span>
              <div class="row" style="margin-top: 13px;">
                <div class="col-5">
                  <input animated="true"
                    style="--cancel-button-color: red; border: 2px solid lightslategray; width: 82%; text-indent: 15px; border-radius: 11px;"
                    placeholder="search" #filter_term [(ngModel)]="search_term"
                    (ngModelChange)="search(filter_term.value)">
                </div>
                <div class="col-5">
                  <div class="form-group">
                    <select class="form-control dropdown_box" #all_route_id matNativeControl>
                      <option value="" style="font-size: 16px;">Select Route</option>
                      <option *ngFor="let route of routes" [value]="route['id']" style="font-size: 16px">{{route['name']}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-2">
                  <button mat-raised-button (click)="allrouteSelected(all_route_id.value)">Submit</button>
                </div>
              </div>

              <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="businesses" *ngIf="display_all_business || all_selected_route_id != null"
                [cdkDropListConnectedTo]="[doneList]" class="example-list"
                (cdkDropListDropped)="drop($event, 'route_to_business')">
                <div class="example-box" *ngFor="let business of businesses" cdkDrag [cdkDragData]="business"
                  style="    font-size: 18px;padding: 13px;">
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  {{business['name']}}
                </div>
              </div>
            </div>
          </div>

          <div class="col example-container" style="background: #c9f5c9;padding: 14px;">

            <h2>Route</h2>
            <p style="    font-size: 20px;">Booths attached to route<span style="    font-weight: 600;"> {{selected_route_name }}</span></p>
            <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="route_businesses"
              [cdkDropListConnectedTo]="[todoList]" class="example-list"
              (cdkDropListDropped)="drop($event, 'business_to_route')" style="margin-top: 25px;    cursor: auto !important;">
              <div class="row example-box" *ngFor="let business of route_businesses; let business_index = index" cdkDrag [cdkDragData]="business"
                 style="    font-size: 18px;padding: 13px;    cursor: auto !important;">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="col-6">
                  {{business['ordinal']}}. {{business['name']}}
                </div>
                <div class="col-3">
                  <button (click)="removeBusinessFromRoute(business.id)" mat-raised-button class="cancel">Detach</button>
                </div>
                <div class="col-3">
                  <button (click)="ChangeActiveStatus(business.id, false)" mat-stroked-button *ngIf="business['business_is_active']" color="primary">Deactivate</button>
                  <button (click)="ChangeActiveStatus(business.id, true)" mat-stroked-button *ngIf="!business['business_is_active']" color="warn">Activate</button>
                  <!-- <button mat-icon-button color="accent"><mat-icon>menu</mat-icon></button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!is_route_change_available" style="text-align: center;">
      <h2>Route Booth Change Option will enable after 10 Am Only.</h2>
    </div>
  </div>
</section>
